import { render, staticRenderFns } from "./SmsChannelSettings.vue?vue&type=template&id=d97e3be4&scoped=true"
import script from "./SmsChannelSettings.vue?vue&type=script&lang=js"
export * from "./SmsChannelSettings.vue?vue&type=script&lang=js"
import style0 from "./SmsChannelSettings.vue?vue&type=style&index=0&id=d97e3be4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97e3be4",
  null
  
)

export default component.exports